import { useContext, useEffect } from 'react';

import { VehicleLookupContext } from 'Context/vehicleLookup';
import { VehicleContext } from 'Context/vehicles';

import { snowplowEvent } from 'Utilities/analytics';
import { useReturningUser } from 'Utilities/hooks/useReturningUser';
import useGetEnquiryStatus from 'Utilities/vehicles/hooks/useGetEnquiryStatus';

export const LogReturningUser = () => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);
  const { vehicleState = [] } = useContext(VehicleContext);
  const isReturningUser = useReturningUser();
  const { getEnquiryStatus } = useGetEnquiryStatus();

  const { enquiry } = vehicle ?? {};
  const { dpEnquiryId, dpStateSlug } = enquiry ?? {};

  const originalVehicle = vehicleState.find((v) => v.enquiry?.dpEnquiryId === dpEnquiryId);
  const { enquiry: originalEnquiry } = originalVehicle ?? {};
  const { dpStateSlug: originalDpStateSlug } = originalEnquiry ?? {};

  useEffect(() => {
    const getDpStateSlug = async () => {
      if (!dpEnquiryId) {
        return;
      }

      const fetchedDpSlug = await getEnquiryStatus(dpEnquiryId);

      snowplowEvent({
        data: {
          dpEnquiryId,
          fetchedDpSlug,
          isReturningUser,
          match: (fetchedDpSlug === dpStateSlug),
          vehicleLookupSlug: dpStateSlug,
          vehiclesSlug: originalDpStateSlug,
        },
        schema: 'dp_slug_status',
      });
    };

    getDpStateSlug();
  }, [
    dpEnquiryId,
    dpStateSlug,
    getEnquiryStatus,
    isReturningUser,
    originalDpStateSlug,
  ]);

  return null;
};
